import { createParser } from "nuqs";

export const USER_SETTINGS_MODAL_QUERY_PARAM = "user-settings";

export const USER_SETTINGS_TABS = [
    "profile",
    "secrets",
    "git-authentications",
    "personal-access-tokens",
    "integrations",
    "experiments",
] as const;

export type UserSettingsTab = (typeof USER_SETTINGS_TABS)[number];

export const parseAsUserSettingsTab = createParser<UserSettingsTab>({
    parse(queryValue) {
        if (USER_SETTINGS_TABS.includes(queryValue as UserSettingsTab)) {
            return queryValue as UserSettingsTab;
        }
        return null;
    },
    serialize(value) {
        return value;
    },
});
